import { render, staticRenderFns } from "./assignee.vue?vue&type=template&id=7adea4cc&"
import script from "./assignee.vue?vue&type=script&lang=js&"
export * from "./assignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports